import * as React from 'react';
import { withGoogleMap, withScriptjs, GoogleMap } from 'react-google-maps';
import MarkerWithTooltip from './MarkerWithTooltip';
import {MAP} from 'react-google-maps/lib/constants'
import { VTMapStyle } from './VTMapConstants';
import { colorStatusMapping } from 'src/colorScheme/containerStatus';
class MapWithMarkerAndTooltip extends React.PureComponent<any, any> {
  refObj: any = {};

  handleMapRef = (ref) => {
    if (!ref) return;
    this.refObj.map = ref;
    this.refObj.mapObject = ref.context[MAP];
  };

  getMarkerIcon = (tag?) => ({
    path: "M 0 0 m -8 0 a 8 8 0 1 0 16 0 a 8 8 0 1 0 -16 0",
    fillColor: colorStatusMapping[tag || this.props.tag],
    fillOpacity: 100,
  });

  onTooltipClose = () => {
    const { map, mapObject } = this.refObj;
    this.props.setSelectedCardId(undefined);
    map.panTo(this.props.center);
    mapObject.setZoom(this.props.zoom);
  }
 
  getMarkers = () => {
    const { markerObjects, icon, tooltipsArray, selectedCardId } = this.props;
    return markerObjects.map((marker, i) => {
      return <MarkerWithTooltip
      markerPosition={marker.position}
      icon={icon || this.getMarkerIcon(marker?.tag)}
      renderTooltip={() => tooltipsArray[i]}
      isOpen={marker?.id === selectedCardId}
      onMarkerClick={() => this.props.setSelectedCardId(marker.id)}
      onTooltipClose={this.onTooltipClose} />
    })
  }

  render() {
    const { zoom, center, markerPosition, icon, renderTooltip, isMultiple } = this.props;
    return <GoogleMap
    zoom={zoom || 3}
    ref={this.handleMapRef}
    defaultCenter={center || { lat: 0, lng: 0 }}
    options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        keyboardShortcuts: false,
        zoomControl: false,
        scrollwheel: false,
        styles: VTMapStyle,
    }}
    >
     {isMultiple ? this.getMarkers() :
     <MarkerWithTooltip
     markerPosition={markerPosition}
     icon={icon || this.getMarkerIcon()}
     renderTooltip={renderTooltip}
     isOpen={this.props.isOpen} />}   
    </GoogleMap>;
  }
}
export default withScriptjs(withGoogleMap(MapWithMarkerAndTooltip));